<template>
    <div class="center-header">
        <!-- 顶部欢迎信息栏 -->
        <div class="top-bar">
            <div class="container">
                <div class="welcome-message">
                    <img src="@/assets/images/1.png" alt="" class="welcome-icon">
                    <span>欢迎来到搏亿购！</span>
                    <span style="color: #333;">{{ userInfo.nickname }}</span>
                    <span class="logout-btn" @click="handleLogout">退出登录</span>
                </div>
                <div class="top-nav">
                    <router-link to="/buyer" class="nav-link">买家中心</router-link>
                    <span class="nav-divider">|</span>
                    <router-link to="/seller" class="nav-link">卖家中心</router-link>
                </div>
            </div>
        </div>

        <!-- 主头部区域 -->
        <div class="main-header">
            <div class="container">
                <!-- Logo区域 -->
                <div class="logo-section">
                    <el-tooltip content="回到首页" placement="top" effect="dark">
                        <router-link to="/">
                            <img src="@/assets/logo.png" alt="博亿购" class="logo-icon" />
                        </router-link>
                    </el-tooltip>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CenterHeader',
    data() {
        return {}
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        userInfo() {
            return this.$store.getters.getUserInfo;
        }
    },
    methods: {
        handleLogout() {
            this.$store.dispatch('logout');
            this.$router.push('/');
        }
    }

}
</script>

<style scoped>
.center-header {
    background-color: #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 顶部欢迎信息栏 */
.top-bar {
    background-color: #F9F9F9;
    color: #333333;
    padding: 10px 0;
}

.top-bar .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.welcome-message {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #286CED;
}

.welcome-icon {
    width: 12px;
    height: 12px;
    margin-right: 8px;
}

.top-nav {
    display: flex;
    align-items: center;
    gap: 10px;
}

.logout-btn {
    margin-left: 8px;
    color: #333333;
    text-decoration: none;
    font-size: 12px;
    cursor: pointer;
}

.nav-link {
    color: #333333;
    text-decoration: none;
    font-size: 12px;
    cursor: pointer;

}

.logout-btn:hover {
    color: #286CED;
}

.nav-link:hover {
    color: #286CED;
}

.nav-divider {
    color: #ccc;
}

/* 主头部区域 */
.main-header {
    padding: 20px 0;
}

.main-header .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    align-items: center;
}

/* Logo样式 */
.logo-section {
    flex: 0 0 auto;
}

.logo {
    display: flex;
    align-items: center;
    text-decoration: none;
    gap: 10px;
}

/* 彩色Logo图标 */
.logo-icon {
    /* width: 137px; */
    height: 69px;
    margin-right: 10px;
}

.logo-part {
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    opacity: 0.8;
}

.logo-part-1 {
    background-color: #ff6b6b;
    top: 0;
    left: 0;
}

.logo-part-2 {
    background-color: #4ecdc4;
    top: 0;
    right: 0;
}

.logo-part-3 {
    background-color: #45b7d1;
    bottom: 0;
    left: 0;
}

.logo-part-4 {
    background-color: #96ceb4;
    bottom: 0;
    right: 0;
}

.logo-text {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .top-bar .container {
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
    }

    .top-nav {
        gap: 8px;
    }

    .logo-text {
        font-size: 20px;
    }

    .logo-icon {
        width: 137px;
        height: 69px;
        margin-right: 10px;
    }

    .logo-part {
        width: 17px;
        height: 17px;
    }
}
</style>